import { pluralize } from '../../../../../utils/pluralize';
import { ProductDomain } from '../../../../product/ProductDomain/ProductDomain';
import { Typography } from '../../../../typography/Typography';
import { AdvertisingProductCardSourceProps } from './types';

export const AdvertisingProductCardSource: React.FC<AdvertisingProductCardSourceProps> = ({
    offers,
}) => {
    const offersCount = offers.length;

    if (offersCount > 1) {
        return (
            <Typography variant="caption" color="secondary" width="100%" noWrap>
                {`${offersCount} ${pluralize(offersCount, 'магазин', 'магазина', 'магазинов')}`}
            </Typography>
        );
    }

    const firstOffer = offers[0];
    const domain = firstOffer.url ? new URL(firstOffer.url).hostname : undefined;

    return domain ? <ProductDomain domain={domain} /> : null;
};
